import React from 'react';

interface State {
  err: Error | null;
}

/**
 * Top-level error boundary so a runtime error in any page doesn't reduce the
 * Telegram WebView to a blank white screen — instead we show the actual error
 * with a "Reload" button.
 */
export class ErrorBoundary extends React.Component<{ children: React.ReactNode }, State> {
  override state: State = { err: null };

  static getDerivedStateFromError(err: Error): State {
    return { err };
  }

  override componentDidCatch(err: Error, info: React.ErrorInfo) {
    // eslint-disable-next-line no-console
    console.error('App error:', err, info?.componentStack);
  }

  override render() {
    if (!this.state.err) return this.props.children;
    return (
      <div className="m-4 space-y-3 rounded-2xl border border-destructive/40 bg-destructive/10 p-4 text-sm">
        <div className="font-bold text-destructive">Что-то пошло не так</div>
        <pre className="whitespace-pre-wrap break-words text-xs text-destructive/90">
          {this.state.err.message}
        </pre>
        <button
          type="button"
          onClick={() => {
            try {
              localStorage.removeItem('chernova-query-cache');
            } catch {}
            window.location.reload();
          }}
          className="w-full rounded-xl bg-destructive px-3 py-2 text-sm font-semibold text-destructive-foreground"
        >
          Перезагрузить
        </button>
      </div>
    );
  }
}
